import * as React from "react";
import { Phone, Clock, ShieldCheck, MapPin, Wrench, ArrowRight, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
export default function HeroBanner() {
  const highlights = [{
    label: "24/7 Rapid Response",
    icon: Clock
  }, {
    label: "Licensed & Insured",
    icon: ShieldCheck
  }, {
    label: "Local Jonesboro Team",
    icon: MapPin
  }];
  return <section id="herobanner" data-nav="dark" className="relative overflow-hidden bg-primary text-primary-foreground py-16 sm:py-24 lg:py-28">
      {/* Background visual elements */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px] pointer-events-none" />
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-accent/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-accent/15 blur-3xl pointer-events-none" />

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8">
          {/* Main Copy Area */}
          <div className="lg:col-span-7 flex flex-col items-start text-left space-y-6">
            <Badge variant="outline" className="border-accent text-accent bg-accent/10 px-3.5 py-1 text-sm font-semibold tracking-wide uppercase rounded-full">
              <Clock className="size-3.5 mr-1.5 text-accent" />
              24/7 Emergency Plumber in Clayton County
            </Badge>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-tight">
              Plumbing Services in <span className="text-accent underline decoration-accent/40 decoration-wavy decoration-2">Jonesboro, GA</span>
            </h1>

            <p className="text-lg sm:text-xl text-primary-foreground/90 max-w-2xl font-normal leading-relaxed">
              Fast, Reliable Plumbing Help Available 24/7 in Your Neighborhood. From burst pipes and clogged drains to water heater failures, our local technicians are ready to help now.
            </p>

            {/* CTA Group */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 w-full sm:w-auto pt-2">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-bold px-8 py-6 text-base shadow-lg rounded-md">
                <Link to="/contact/">
                  Request Service Now
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>

              <Button asChild size="lg" variant="outline" className="bg-primary-foreground/10 border-accent/40 text-white hover:bg-primary-foreground/20 font-bold px-7 py-6 text-base rounded-md">
                <a href="tel:4708479076">
                  <Phone className="mr-2 size-5 text-accent" />
                  Call (470) 847-9076
                </a>
              </Button>
            </div>

            {/* Trust bullet tags */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-4 w-full border-t border-primary-foreground/20">
              {highlights.map((item, i) => {
              const IconComponent = item.icon;
              return <div key={item.label} data-index={i} className="flex items-center gap-2 text-sm font-medium text-primary-foreground/90">
                    <IconComponent className="size-4 text-accent shrink-0" />
                    <span>{item.label}</span>
                  </div>;
            })}
            </div>
          </div>

          {/* Right Image / Feature Card */}
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-card">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1778865/img/jonesboro_emergency_plumber_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1778865/img/jonesboro_emergency_plumber_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1778865/img/jonesboro_emergency_plumber_hero.png-wvc-sizes" alt="Professional plumbing technician working on pipe repairs in Jonesboro GA" loading="eager" decoding="async" className="w-full h-80 sm:h-96 lg:h-[440px] object-cover" />

              {/* Floating Emergency Box */}
              <div className="absolute bottom-4 left-4 right-4 bg-background/95 backdrop-blur-md p-4 rounded-xl border border-border shadow-lg text-foreground">
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="size-11 rounded-lg bg-accent/20 flex items-center justify-center shrink-0">
                      <Wrench className="size-6 text-accent" />
                    </div>
                    <div>
                      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">Need Immediate Help?</p>
                      <p className="text-base font-bold text-foreground">No Extra Charges for Nights & Weekends</p>
                    </div>
                  </div>
                  <div className="hidden sm:flex items-center text-accent">
                    <CheckCircle2 className="size-6" />
                  </div>
                </div>
              </div>
            </div>

            {/* Experience Pill Badge */}
            <div className="absolute -top-3 -right-3 hidden sm:flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-full font-bold text-sm shadow-md">
              <ShieldCheck className="size-4" />
              <span>100% Satisfaction Guarantee</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}